<template>
  <div>
    <div class="row mb-3">
      <div class="col-md-12">
        <div class="alert alert-info" v-if="solicitud.estado === 'EN_ADJUDICACION'">
          <i class="fa fa-info-circle me-2"></i>
          El proceso ha sido autorizado por la/el RPA. Proceda a adjudicar la contratación.
        </div>
        <div class="alert alert-success" v-else-if="solicitud.estado === 'ADJUDICADA'">
          <i class="fa fa-check-circle me-2"></i>
          <strong>Contratación adjudicada</strong> - El proveedor/consultor ha sido seleccionado.
        </div>
      </div>
    </div>

    <!-- Formulario de adjudicación v-if="solicitud.estado === 'EN_ADJUDICACION'" -->
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header bg-light"><h6 class="mb-0">Adjudicación de la Contratación</h6></div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group mb-2">
                  <label class="form-label">Tipo de Adjudicado *</label>
                  <select v-model="adjudicacion.tipo_adjudicado" class="form-select" required>
                    <option value="">Seleccionar</option>
                    <option value="PROVEEDOR">Proveedor (Empresa)</option>
                    <option value="CONSULTOR">Consultor (Persona Natural)</option>
                  </select>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-2">
                  <label class="form-label" v-if="adjudicacion.tipo_adjudicado === 'PROVEEDOR'">Proveedor *</label>
                  <label class="form-label" v-else>Consultor *</label>
                  <select v-model="adjudicacion.id_adjudicado" class="form-select" required>
                    <option value="">Seleccionar</option>
                    <option v-if="adjudicacion.tipo_adjudicado === 'PROVEEDOR'" v-for="prov in proveedores" :key="prov.id" :value="prov.id">
                      {{ prov.razon_social }} (NIT: {{ prov.nit }})
                    </option>
                    <option v-else v-for="cons in proveedores" :key="cons.id" :value="cons.id">
                      {{ cons.razon_social }} : ({{ cons.nombre_contacto }} - NIT: {{ cons.nit }})
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-2">
                  <label class="form-label">Monto Adjudicado (Bs) *</label>
                  <input v-model="adjudicacion.monto_adjudicado" type="number" step="0.01" class="form-control" required >
                </div>
              </div>
              <div class="col-md-12 mt-2">
                <BButton variant="success" @click="adjudicar" :disabled="loading">
                  <i class="fa fa-gavel me-1"></i> Adjudicar Contratación
                </BButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Mostrar adjudicación existente
    <div class="row mt-3" v-if="adjudicacionExistente">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header bg-light"><h6 class="mb-0">Información de Adjudicación</h6></div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-10">
                <table class="table table-sm">
                  <tr>
                    <td width="20%"><strong>Adjudicado a:</strong></td>
                    <td width="40%">{{ adjudicacionExistente.proveedor.razon_social }}</td>
                    <td width="40%" rowspan="4">

                      <BButton
                        variant="danger"
                        @click="generarPdf"
                        :disabled="generandoPdf"
                        class="mt-3"
                      >
                        <i v-if="generandoPdf" class="fa fa-spinner fa-spin me-1"></i>
                        <i v-else class="fa fa-file-pdf me-1"></i>
                        {{ generandoPdf ? 'Generando PDF...' : 'Nota de Adjudicación (PDF)' }}
                      </BButton>

                    </td>
                  </tr>
                  <tr>
                    <td><strong>Monto Adjudicado:</strong></td>
                    <td><strong class="text-success">Bs. {{ formatNumber(adjudicacionExistente.monto_adjudicado) }}</strong></td>

                  </tr>
                  <tr>
                    <td><strong>Fecha Adjudicación:</strong></td>
                    <td>{{ formatDate(adjudicacionExistente.fecha_adjudicacion) }}</td>
                  </tr>
                  <tr v-if="adjudicacionExistente.nota_adjudicacion_ruta">
                    <td><strong>Nota Adjudicación:</strong></td>
                    <td><a :href="'/storage/' + adjudicacionExistente.nota_adjudicacion_ruta" target="_blank"><i class="fa fa-file-pdf"></i> Ver documento</a></td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    -->
    <!-- ===================== ADJUDICACIONES EXISTENTES (N cards) ===================== -->
    <div class="row mt-3" v-for="(adj, idx) in adjudicacionesExistentes" :key="adj.id">
        <div class="col-md-12">
            <div class="card">
            <div class="card-header bg-light d-flex justify-content-between align-items-center">
                <h6 class="mb-0">
                Información de Adjudicación
                <span v-if="adjudicacionesExistentes.length > 1" class="text-muted">
                    ({{ idx + 1 }} de {{ adjudicacionesExistentes.length }})
                </span>
                </h6>
            </div>
            <div class="card-body">
                <div class="row">
                <div class="col-md-10">
                    <table class="table table-sm">
                    <tr>
                        <td width="20%"><strong>Adjudicado a:</strong></td>
                        <td width="40%">
                        {{ adj.proveedor?.razon_social ?? adj.persona?.razon_social ?? 'N/A' }}
                        </td>
                        <td width="40%" rowspan="5">
                        <!-- PDF por ID de adjudicación -->
                        <BButton
                            variant="danger"
                            @click="generarPdf(adj.id)"
                            :disabled="generandoPdf === adj.id"
                            class="mt-3"
                        >
                            <i v-if="generandoPdf === adj.id" class="fa fa-spinner fa-spin me-1"></i>
                            <i v-else class="fa fa-file-pdf me-1"></i>
                            {{ generandoPdf === adj.id ? 'Generando PDF...' : 'Nota de Adjudicación (PDF)' }}
                        </BButton>
                        </td>
                    </tr>
                    <tr>
                        <td><strong>Tipo:</strong></td>
                        <td>{{ adj.tipo_adjudicado }}</td>
                    </tr>
                    <tr>
                        <td><strong>Monto Adjudicado:</strong></td>
                        <td>
                        <strong class="text-success">
                            Bs. {{ formatNumber(adj.monto_adjudicado) }}
                        </strong>
                        </td>
                    </tr>
                    <tr>
                        <td><strong>Fecha Adjudicación:</strong></td>
                        <td>{{ formatDate(adj.fecha_adjudicacion) }}</td>
                    </tr>
                    <tr v-if="adj.nota_adjudicacion_ruta">
                        <td><strong>Nota Adjudicación:</strong></td>
                        <td>
                        <a :href="'/storage/' + adj.nota_adjudicacion_ruta" target="_blank">
                            <i class="fa fa-file-pdf"></i> Ver documento
                        </a>
                        </td>
                    </tr>
                    </table>
                </div>
                </div>
            </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, onMounted } from 'vue';
import axios from 'axios';
import Swal from 'sweetalert2';
import { BButton } from 'bootstrap-vue-3';

const props = defineProps({ solicitud: { type: Object, required: true } });
const emit = defineEmits(['refresh']);

const loading = ref(false);
//const generandoPdf = ref(false);
const generandoPdf = ref(null);
const archivoSeleccionado = ref(null);
const proveedores = ref([]);
const consultores = ref([]);
// const adjudicacionExistente = ref(null);
const adjudicacionesExistentes = ref([]);

const adjudicacion = ref({
  tipo_adjudicado: '',
  id_adjudicado: '',
  monto_adjudicado: props.solicitud.monto_estimado
});

// Cuando cambia el tipo, limpiar selección
watch(() => adjudicacion.value.tipo_adjudicado, () => {
  adjudicacion.value.id_adjudicado = '';
});

const fetchProveedores = async () => {
  try {
    const response = await axios.get('/adjudicacion/proveedores/listar');
    proveedores.value = response.data.data;
  } catch (error) { console.error(error); }
};

const fetchConsultores = async () => {
  try {
    const response = await axios.get('/adjudicacion/consultores/listar');
    consultores.value = response.data.data;
  } catch (error) { console.error(error); }
};

const fetchAdjudicacion = async () => {
  try {
    const response = await axios.get(`/adjudicacion/${props.solicitud.id}`);
    if (response.data.data) {
        adjudicacionesExistentes.value = Array.isArray(response.data.data)
        ? response.data.data
        : (response.data.data ? [response.data.data] : []);
        // adjudicacionExistente.value = response.data.data;
    }
  } catch (error) { console.error(error); }
};

const handleFileUpload = (event) => { archivoSeleccionado.value = event.target.files[0]; };

const adjudicar = async () => {
  if (!adjudicacion.value.tipo_adjudicado || !adjudicacion.value.id_adjudicado) {
    Swal.fire('Error', 'Complete todos los datos de adjudicación', 'error');
    return;
  }
  /*
  if (!archivoSeleccionado.value) {
    Swal.fire('Error', 'Debe seleccionar el archivo de la nota de adjudicación', 'error');
    return;
  }
  */
  loading.value = true;
  try {
    const formData = new FormData();
    formData.append('id_solicitud', props.solicitud.id);
    formData.append('tipo_adjudicado', adjudicacion.value.tipo_adjudicado);
    if (adjudicacion.value.tipo_adjudicado === 'PROVEEDOR') {
      formData.append('proveedor_id', adjudicacion.value.id_adjudicado);
    } else {
      formData.append('persona_id', adjudicacion.value.id_adjudicado);
    }
    formData.append('monto_adjudicado', adjudicacion.value.monto_adjudicado);
    formData.append('nota_adjudicacion', archivoSeleccionado.value);

    await axios.post('/adjudicacion/guardar', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
    Swal.fire('Éxito', 'Contratación adjudicada correctamente', 'success');
    fetchAdjudicacion();
    emit('refresh');
  } catch (error) {
    Swal.fire('Error', error.response?.data?.message || 'Error al adjudicar', 'error');
  } finally { loading.value = false; }
};
/**
 * Generar PDF de la Nota de Adjudicación
 */
const generarPdf = async (idAdjudicacion) => {
  generandoPdf.value = idAdjudicacion;
  try {
    const response = await axios.get(`/adjudicacion/pdf/${idAdjudicacion}`, {
     //const response = await axios.get(`/adjudicacion/pdf/${props.solicitud.id}`, {
      responseType: 'blob'
    });

    // Crear URL del blob y descargar
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `nota_adjudicacion_${props.solicitud.codigo}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    Swal.fire('Éxito', 'PDF generado correctamente', 'success');
  } catch (error) {
    console.error('Error al generar PDF:', error);
    Swal.fire('Error', error.response?.data?.message || 'No se pudo generar el PDF', 'error');
  } finally {
    generandoPdf.value = false;
  }
};
const formatNumber = (n) => new Intl.NumberFormat('es-BO', { minimumFractionDigits: 2 }).format(n);
const formatDate = (date) => date ? new Date(date).toLocaleDateString('es-BO') : 'N/A';

onMounted(() => { fetchProveedores(); fetchConsultores(); fetchAdjudicacion(); fetchAdjudicacion(); });
</script>
